import paper from 'paper';
import store from '../store';
import { Size, Point } from 'paper';

export default {
    isClic(event) {
        return event.downPoint.equals(event.point);
    },

    boundingRectangle(point, size) {
        let rectangle = new paper.Rectangle(point, size);
        return new paper.Rectangle(rectangle.topLeft, rectangle.size);
    },

    startsInMaterial(event) {
        return paper.project.layers.view.hitTest(event.downPoint) ? true: false
    },

    centerAndRadius(scalingCenterPoint, point, handle) {
        let vector = point.subtract(scalingCenterPoint).divide(2),
            positiveVector = new Point(Math.abs(vector.x), Math.abs(vector.y)),
            radius = positiveVector.x > positiveVector.y ? Math.round(positiveVector.x * 10) / 10 : Math.round(positiveVector.y * 10) / 10,
            centerVector,
            cuttingOptions = store.getters.cuttingOptions;

        if(cuttingOptions.drillingThresholdDiameter/2 > radius) radius = this.drillingDiameter(radius, cuttingOptions.drillingThresholdDiameter/2, cuttingOptions);
            

        if (handle.startsWith('width')) {
            centerVector = new Point(vector.x < 0 ? -radius : radius, 0);
        }
        if (handle.startsWith('height')) {
            centerVector = new Point(0, vector.y < 0 ? -radius : radius);
        }
        if (handle.startsWith('corner')) {
            centerVector = new Point(vector.x < 0 ? -radius : radius, vector.y < 0 ? -radius : radius);
        }

        return {
            center: scalingCenterPoint.add(centerVector),
            radius
        };
    },

    defaultSize(proportion, event) {
        let windowProp = window.innerWidth / window.innerHeight,
            sizeProp = 0.4,
            cutProp = this.startsInMaterial(event) ? 0.8 : 1,
            zoom = store.getters.zoom,
            width,
            height;

        if (windowProp > proportion) {
            height = window.innerHeight * sizeProp * cutProp / zoom;
            width = height * proportion;
        } else {
            width = window.innerWidth * sizeProp * cutProp/ zoom;
            height = width / proportion;
        }

        return new Size(width, height);
    },

	drillingDiameter(radius, treshhold, cuttingOptions){
        let drillingDiameter = Object.fromEntries(Object.entries(cuttingOptions).filter(([key]) => key.startsWith('drillingDiameter')));
        drillingDiameter = Object.values(drillingDiameter).sort(function(a, b) {return a - b;});
        for (let index = 0; index < drillingDiameter.length; index++) {
            const element = drillingDiameter[index]/2;
            if(element >= Math.round(radius*10)/10) return element;
        }
        return treshhold;      
    },

    setToOrigin(boundingRectangle, event, circle = null){
        if(circle){
            var newCenter = store.getters.center.add(new Point(boundingRectangle.x,boundingRectangle.y).multiply(-1));
            store.dispatch('setCenter',newCenter);
            return new Point(0,0);
        }
        var newCenter = store.getters.center.add(new Point(event.downPoint.x,event.point.y).multiply(-1));
        store.dispatch('setCenter',newCenter);
        boundingRectangle.x = 0;
        boundingRectangle.y = -boundingRectangle.height;
        return boundingRectangle;
    }
}
